@let control = getControl();

<div class="checkbox-control-wrapper">
  <htx-checkbox-field
    [ctrl]="ctrl()"
    [label]="label()"
    [required]="required()">
  </htx-checkbox-field>

  @if (ctrl().invalid && (ctrl().touched || ctrl().dirty)) {
    <htx-error-field
      [control]="control"
      [errorMessages]="errorMessages()">
    </htx-error-field>
  }
</div>
